// extracted by mini-css-extract-plugin
module.exports = {"fontAwesome":"_base-icon_fontAwesome_BOb2-"};